import { Card } from 'react-bootstrap';

const Cta = () => {
  const googleReviewLink = "https://www.google.com/search?q=PARKES+ABOGADOS+Opiniones..."; // Puedes usar tu url completa aquí

  return (
    <section className="py-6 bg-body-tertiary text-center">
      <div className="container-small">
        <Card className="border-0 p-5 bg-primary-subtle rounded-3">
          <Card.Body>
            <h3 className="fw-bold mb-3 text-primary-dark">Dejanos tu opinión</h3>
            <p className="text-muted mb-4">Tu experiencia nos ayuda a seguir mejorando día a día.</p>
            <div className="d-flex justify-content-center gap-2 fs-2 text-warning">
              {[1, 2, 3, 4, 5].map((val) => (
                <a 
                  key={val} 
                  href={googleReviewLink} 
                  target="_blank" 
                  rel="noreferrer" 
                  className="text-decoration-none text-warning star-click"
                  style={{ cursor: 'pointer' }}
                >
                  ★
                </a>
              ))}
            </div>
          </Card.Body>
        </Card>
      </div>
    </section>
  );
};

export default Cta;